import { Component,Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-source-hover-modal',
  templateUrl: './source-hover-modal.component.html',
  styleUrls: ['./source-hover-modal.component.scss']
})
export class SourceHoverModalComponent implements OnInit {
  @Input() profileInformation: any = {}
  constructor() { }

  ngOnInit(): void {
    
  }


}


